import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history", // 上线前添加
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {},
        },
        {
          path: "/newsDetail",
          name: "newsDetail",
          meta: {
            hide: true,
            hideBottom: true,
          },
          component: (resolve) => require(["@/view/newsDetail"], resolve),
        },
        {
          path: "/aboutus",
          name: "aboutus",
          component: (resolve) => require(["@/view/aboutus"], resolve),
        },
        {
          path: "/ourFocus",
          name: "ourFocus",
          component: (resolve) => require(["@/view/ourFocus"], resolve),
          meta: {
            hideBottom: true,
          },
        },
        {
          path: "/ourFocus1",
          name: "ourFocus1",
          component: (resolve) => require(["@/view/ourFocus1"], resolve),
          meta: {
            hideBottom: true,
          },
        },
        {
          path: "/searchPage",
          name: "searchPage",
          component: (resolve) => require(["@/view/searchPage"], resolve),
          meta: {
            hideBottom: true,
          },
        },
        {
          path: "/orderDetail",
          name: "searchPage",
          component: (resolve) => require(["@/view/orderDetail"], resolve),
          meta: {
            hideBottom: true,
            hideTitle: true,
          },
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: (resolve) => require(["@/view/NewsInformation"], resolve),
        },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js